import React from 'react';

import { useIntl } from 'react-intl';

import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { Badge } from 'src/registry/ui/Badge';
import { cn } from 'src/utils/shadcn';

type VersionStatusBadgeProps = {
    isCurrentVersion?: boolean;
    validFrom?: string;
};
const VersionStatusBadge = ({ isCurrentVersion, validFrom }: VersionStatusBadgeProps) => {
    const { formatMessage } = useIntl();

    const { validFromInFuture, message } = React.useMemo(() => {
        const validFromInFuture = !isCurrentVersion && !!validFrom && new Date() < new Date(validFrom);

        if (isCurrentVersion)
            return {
                validFromInFuture,
                message: pricingPlanMessages.currentVersion,
            };
        if (validFromInFuture)
            return {
                validFromInFuture,
                message: pricingPlanMessages.scheduledChanges,
            };

        return {
            validFromInFuture,
            message: pricingPlanMessages.pastVersion,
        };
    }, [isCurrentVersion, validFrom]);

    return (
        <span className="flex">
            <Badge className="max-w-full">
                <span
                    className={cn(
                        'size-1.5 rounded-full bg-red-600',
                        isCurrentVersion && 'bg-emerald-600',
                        validFromInFuture && 'bg-yellow-500',
                    )}
                />
                {formatMessage(message)}
            </Badge>
        </span>
    );
};

export default VersionStatusBadge;
